import React from 'react';
import PropTypes from 'prop-types';
import cancelEvent from '../../../services/mini/cancelEvent';
import * as ReactDOM from 'react-dom';

function getDocumentOffsetPosition(el) {
    var position = {
        top: el.offsetTop,
        left: el.offsetLeft
    };
    if (el.offsetParent) {
        var parentPosition = getDocumentOffsetPosition(el.offsetParent);
        position.top += parentPosition.top;
        position.left += parentPosition.left;
    }
    return position;
}

class Menu extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            opened: false,
            top: 0,
            left: 0
        };

    }

    componentDidMount(){
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
        document.removeEventListener('keydown', this.onKeyCb, false);
        document.removeEventListener('click', this.handleClickOutsideCb, false);
    }

    handleClickOutsideCb = (e) => {
        if (!this.state.opened) return;
        if (this._isMounted === false) return;
        const domNode = ReactDOM.findDOMNode(this);
        const clickedEl = e.target;

        if ((!domNode || !domNode.contains(clickedEl))) {
            this.closeMenu(e);
        }
    }

    onKeyCb = (e) => {
        const keyCode = e.keyCode;

        if (keyCode === 27) {
            this.closeMenu(e);
        }
    }

    isFixed() {
        return this.props.fixed === true;
    }

    toggleState = (e) => {
        const { afterOpenCb, itemHeight, children } = this.props;
        const { opened } = this.state;
        let newState = { opened: !opened };

        cancelEvent(e);

        if (newState.opened && this.isFixed()) {

            let yPos = e.clientY;

            if (itemHeight) {
                let deltaY = window.innerHeight - itemHeight * children.length - yPos;
                if (deltaY <= 0) {
                    yPos = yPos + deltaY;
                }
            }

            newState = {
                ...newState,
                top: yPos,
                left: e.clientX
            };
        }

        this.setState(newState);

        if (!opened) {
            document.addEventListener('mousedown', this.handleClickOutsideCb, false);
            document.addEventListener('keydown', this.onKeyCb, false);

            if (afterOpenCb) {
                afterOpenCb();
            }
        }
    }

    closeMenu = (e) => {
        this.setState({ opened: false });
        cancelEvent(e);
        document.removeEventListener('mousedown', this.handleClickOutsideCb, false);
        document.removeEventListener('keydown', this.onKeyCb, false);

        const { afterCloseCb } = this.props;

        if (afterCloseCb) {
            afterCloseCb();
        }
    }

    render() {
        const { children, width, button, className } = this.props;
        const { opened, left, top } = this.state;
        let style = {};

        if (this.props.top) {
            style.top = `${this.props.top}px`;
        }

        if (this.isFixed()) {
            style.top = `${top}px`;
            style.left = `${left}px`;
        }

        if (width) {
            style.width = `${width}px`;
        }

        return (
            <div className={`menu ${this.isFixed() && 'fixed'} ${className}`}>
                <span onClick={this.toggleState}>{button ? button : <i className="icon icon-three-dots" />}</span>
                {opened && <div className="menu-items" onClick={this.closeMenu} style={style}>
                    {children.map((el, i) => <div key={i}>{el}</div>)}
                </div>}
            </div>
        );
    }
}

Menu.propTypes = {
    children: PropTypes.array.isRequired,
    afterOpenCb: PropTypes.func,
    afterCloseCb: PropTypes.func,
};

export default Menu;